<script lang="ts">
  import type { Filter } from '../global'

  export let nav: Filter.CategoryNav
</script>

<span class="inline-block md:hidden">{nav.short}</span>
<span class="hidden md:inline-block">{nav.long}</span>
